import { useRecoilState } from 'recoil';
import React from 'react';
import ReactDOM from 'react-dom';
import { useEffect} from 'react';
import { Upload, Button, message, Modal, Input, Tree } from 'antd';
import { UploadOutlined, CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { useState } from 'react';
import { nullableTypeAnnotation } from '@babel/types';
import { useFetchWrapper } from '_helpers';
import { Table, Tag, Space } from 'antd';
const { TextArea } = Input;


export { UploadForm };


function UploadForm(props) {
  const [fileList, setFileList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [modalTitle, setModalTitle] = useState("Đang upload");
  const [log, setLog] = useState("Đang upload\n");
  const [result, setResult] = useState({
    registered: [],
    failed: []
  });

  const fetchWrapper = useFetchWrapper();
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    window.location.reload();
  };

  async function handleUpload(){
    showModal();
    setLog("Đang xử lý...");
    if (!fileList || fileList.length === 0) return;

    for (const file of fileList) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        for (const [k, v] of Object.entries(props.extraFormData || {})) {
          formData.append(k, v);
        }

        const response = await fetchWrapper.post(props.formurl, null, formData);

        let rawjson;
        try {
          rawjson = await response.json();
        } catch (parseErr) {
          setModalTitle("Upload thất bại");
          setLog("Máy chủ trả về phản hồi không hợp lệ (không phải JSON).\nHTTP status: " + response.status);
          continue;
        }

        if ("status" in rawjson) {
          if (rawjson.status === "Success") {
            setModalTitle("Upload thành công");
          } else {
            setModalTitle("Upload thất bại");
          }
          if (rawjson.message && typeof rawjson.message === "object" && "registered" in rawjson.message) {
            setResult(rawjson.message);
          }
          setLog(JSON.stringify(rawjson.message, null, 4));
        }
      } catch (err) {
        setModalTitle("Upload thất bại");
        setLog("Lỗi kết nối: " + (err.message || String(err)));
      }
    }
  };
const delError = (col) => {
  var abc = [...col]
  delete abc[col.length-1]
  return abc;
}
  const cprops = {
      // multiple:true,
      onRemove: file => {
        setFileList(fileList => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          return newFileList;
        });
      },
      beforeUpload: file => {
        setFileList(fileList => ([...fileList, file]));
        return false;
      },
      fileList,
    };

    return (
      <div>
        <Modal title={modalTitle} visible={isModalVisible} onCancel= {handleOk} footer={[]}style={{ height: 700}} width={1000}>
          <CheckCircleTwoTone twoToneColor="var(--ok)" className="dbportal-result-icon"/> Dữ liệu thêm thành công: <b>{result.registered.length}</b>
          <br/>
          <CloseCircleTwoTone twoToneColor="var(--bad)" className="dbportal-result-icon"/> Dữ liệu thêm thất bại: <b>{result.failed.length}</b>
          <br/>
          <br/>
          {/* <Tree
            treeData={result}
          />            */}
          <b>Thành công:</b>
          {/* <TextArea rows={10} value = {log} style={{ resize: "none"}} /> */}
          {props.columns && <Table columns={delError(props.columns)} dataSource={result.registered} />}

          <b>Thất bại:</b>
          {/* <TextArea rows={10} value = {log} style={{ resize: "none"}} /> */}
          {props.columns && <Table
            columns={props.columns.map(col =>
              col.dataIndex === 'error'
                ? { ...col, render: v => v ? <span style={{ color: 'var(--bad)' }}>{v}</span> : null }
                : col
            )}
            dataSource={result.failed}
          />}
        </Modal>
        <Upload {...cprops}>
          <Button icon={<UploadOutlined /> } >Chọn file</Button>
        </Upload>
        <Button
          type="primary"
          onClick={handleUpload}
          disabled={fileList?.length === 0}
          style={{ marginTop: 16 }}
        >
          Tải lên
        </Button>
      </div>
    );
  
}